// SPEC §6: verificacion automatica de recortes. Dos pixeles de desborde rebanan un
// acento y pasan desapercibidos a ojo; por eso corre sola antes de exportar. Si devuelve
// algo distinto de cero, la imagen no se publica.
export function verificarRecortes(nodo) {
  if (!nodo) return { desbordes: 0, nombresCortados: 0, total: 0 };
  let desbordes = 0;
  nodo.querySelectorAll('.tarjeta').forEach((t) => {
    const r = t.getBoundingClientRect();
    t.querySelectorAll('div, span').forEach((d) => {
      const q = d.getBoundingClientRect();
      if (q.bottom > r.bottom + 1 || q.right > r.right + 1 || q.top < r.top - 1) desbordes++;
    });
  });
  let nombresCortados = 0;
  nodo.querySelectorAll('.nm').forEach((n) => {
    if (n.scrollWidth > n.clientWidth) nombresCortados++;
  });
  return { desbordes, nombresCortados, total: desbordes + nombresCortados };
}
